import { AsyncGridColumns, ColumnLink } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.subdivision',
    field: 'title',
    sortable: false,
    flex: 1,
    minWidth: 300,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.title}</ColumnLink>,
  },
  {
    headerName: 'column.region',
    field: 'region',
    sortable: false,
    flex: 1,
  },
]
